import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import PreviewPDF from "../../../helpers/previewPDF";
import {
  getRouteConfigs,
  resourcesDeposits,
  resourcesOperators,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Button, Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import FilesListHelper from "../../../helpers/FilesListHelper";
import * as dayjs from "dayjs";

const Deposits = () => {
  let timeElapsed = new Date();
  let dateYesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  const [selects, setSelects] = useState({ operators: [], units: [] });
  const [date, setDate] = useState({ initDate: "", endDate: "" });
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [price, setPrice] = useState(null);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalFile, setModalFile] = useState({
    show: false,
    id: null,
    files: [],
  });

  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [modalPrice, setModalPrice] = useState({ show: false, update: false });
  const [modalObserv, setModalObserv] = useState({
    show: false,
    type: 1,
    id: null,
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateYesterday,
  });
  const [items, setItems] = useState([]);
  const itemBase = {
    id: null,
    date: dateYesterday,
    unit_id: null,
    notes: null,
    amount: null,
    total: null,
    operator_id: null,
    unit_id: null,
    salidas_count: null,
  };
  const [item, setItem] = useState(itemBase);

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const operadores = await resourcesOperators("get", params);
      const units = await resourcesUnits("get", params);
      setSelects({
        ...selects,
        operators: operadores.data,
        units: units.data,
      });
    };
    getSelects();
  }, []);

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesDeposits("get", params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);

  const addUpd = (row) => {
    console.log('row', row)
    if (row?.id) {
      setItem({...row, date: dayjs(row.date.substr(0,10)).format('YYYY-MM-DD')});
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({ ...itemBase });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesDeposits("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesDeposits("get", config).then((response) => {
      if (type == 1) {
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Depósitos.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModalPdf({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      const response = await getRouteConfigs();
      const priceConfig = response.filter((e) => e.configuration_id == 14);
      console.log(priceConfig[0]?.value ?? 0);
      setPrice(priceConfig[0]?.value ?? 0);
    };

    fetchConfigs();
  }, []);

  const columns = Columns(addUpd, destroy, setModalFile, modalFile);
  document.title = "Depósitos | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={true}
              tittle="Depósitos"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionSave={addUpd}
                  addButon={
                    authUser.profile_id == 2 || authUser.profile_id == 3
                  }
                  reportButons={true}
                  actionReportButon={getReports}
                  actionAddButon={() => addUpd()}
                >
                </ButtonHelper>
              </div>
              <div className="col-sm-2">
                <label className="form-label">Fecha:</label>
                <input
                  className="form-control"
                  placeholder="Fecha"
                  name="time"
                  type="date"
                  onChange={(e) =>
                    setFilters({ ...filters, initDate: e.target.value })
                  }
                  value={filters.initDate}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            price={price}
            selects={selects}
          />
        )}
        {modalPdf.show && (
          <PreviewPDF modalPdf={modalPdf} setModalPdf={setModalPdf} />
        )}
        {console.log(modalFile.show)}
        {modalFile.show && (
          <FilesListHelper
            modal={modalFile}
            setModal={setModalFile}
            title="Archivos de Ventas"
            type="sale"
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Deposits;
